import { DocumentState } from '../../common';

export type CreditState =
  | DocumentState.CONTRACT_DRAFT
  | DocumentState.DRAFT
  | DocumentState.REVIEW_MISSING_DATA
  | DocumentState.REVIEW_READY_TO_SEND
  | DocumentState.SENT_FAILED
  | DocumentState.OPEN
  | DocumentState.PAID
  | DocumentState.CANCELED;

export const CreditNonSentStates = [
  DocumentState.CONTRACT_DRAFT,
  DocumentState.DRAFT,
  DocumentState.REVIEW_MISSING_DATA,
  DocumentState.REVIEW_READY_TO_SEND,
  DocumentState.OPEN,
];
export const CreditNoteLockingStates = [DocumentState.PAID, DocumentState.CANCELED];
export const CreditNoteNumberAllocationStates = [DocumentState.PAID];
